import { IFilter } from '../../types/advancedFilters';
import { FacilitiesContainer } from '../../containers/advancedFilters/FacilitiesContainer';

export const facilities: IFilter = {
  component: FacilitiesContainer,
};
